@if (!pdfDoc) {
  <link  [href]="printPdfCssHref" media="print" rel="stylesheet"/>
}
@if (pdfDoc) {
  <link [href]="printPdfCssHref" media="all" rel="stylesheet" (load)="onPrintCssLoaded()" (error)="onPrintCssLoaded()"/>
}
@if (pdfDoc && !isHeadless) {
  <nav class="navbar navbar--central navbar--screen-view fixed-top" style="top: 0px;">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          <a>{{document?.document_name}}</a>
        </div>
        <a href="javascript:;" (click)="closeDocument()" class="navbar-policy__close icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-current"><strong>{{document?.document_name}}</strong></div>
        </div>
      </div>
    </div>
  </nav>
}
@if (!pdfDoc) {
  <nav class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-sub">
        <a href="javascript:;" (click)="closeDocument()"   class="navbar-sub__back">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </a>
        <div class="navbar-sub__nav text-left">
          {{document?.document_name}}
        </div>
        <div class="navbar-sub__more">
          <div class="navbar-sub__search">
            <div class="navbar-sub__search-trigger icon-hover icon-hover--alt" id="search-trigger">
              <svg class="icon">
                <use xlink:href="#search"></use>
              </svg>
            </div>
            <div class="navbar-sub__search-container" id="search-container">
              <div class="form-control__wrap has-clear">
                <input type="search" placeholder="Search" id="search-input" autocomplete="off" class="form-control form-control--sm">
                <a href="#" id="search-clear" class="form-control__clear"><svg class="icon">
                  <use xlink:href="#close-circle-small"></use>
                </svg></a>
              </div>
              <div class="navbar-sub__search-up" title="Prev">
                <svg class="icon">
                  <use xlink:href="#dropdown-up-medium"></use>
                </svg>
              </div>
              <div class="navbar-sub__search-down" title="Next">
                <svg class="icon">
                  <use xlink:href="#dropdown-down-medium"></use>
                </svg>
              </div>
            </div>
            <a href="#"  class="navbar-sub__search-close icon-hover icon-hover--alt" id="search-close">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
          <div class="navbar-sub__share">
            <a href="#modal-share-menu" data-toggle="modal" class="icon-hover icon-hover--alt d-lg-none">
              <svg class="icon">
                <use xlink:href="#share"></use>
              </svg>
            </a>
            <div class="dropdown d-none d-lg-block">
              <a href="#" class="icon-hover icon-hover--alt dropdown-toggle dropdown-toggle--nocaret" data-toggle="dropdown" id="shareDropdown" aria-expanded="false">
                <svg class="icon">
                  <use xlink:href="#share"></use>
                </svg>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <div class="profile-drop">
                  <div class="profile-drop__inner">
                    <ul class="profile-drop__list list-unstyled">
                      <li>
                        <a href="javascript:;" (click)="preparePDF()">
                          <svg class="icon">
                            <use xlink:href="#download"></use>
                          </svg>
                          <span>Download</span>
                        </a>
                      </li>
                      <!-- <li>
                      <a href="#share-email-modal" data-toggle="modal" target="_blank">
                        <svg class="icon">
                          <use xlink:href="#envelope"></use>
                        </svg>
                        <span>Email</span>
                      </a>
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navbar-sub__support">
          <div class="navbar-actions__chat dropdown dropdown--persist" id="chatDropdown">
            <a href="#" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" aria-haspopup="true" aria-expanded="false">
              <span class="d-none d-lg-inline">Help</span>
              <svg class="icon d-lg-none">
                <use xlink:href="#chat"></use>
              </svg>
              <svg class="icon d-none d-lg-inline-block">
                <use xlink:href="#chat"></use>
              </svg>
            </a>
            <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
              <div class="chat-info has-emergency">
                <div class="container">
                  <div class="chat-info__avatar">
                    <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <div class="chat-info__content">
                    <h5>Hi 👋! How can we help?</h5>
                    <p>Start chatting with the next available agent, or if you prefer a friendly voice our
                    licensed Everything.Insure brokers are ready to assist.</p>
                    <a href="#" class="button button--primary">Start Chat</a>
                  </div>
                  <div class="chat-info__close dropdown-close">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </div>
                </div>
                <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                  <div class="container">
                    <div class="accordion__item">
                      <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                        <div class="accordion__title-text">
                          <h6>We can create a quote for you</h6>
                        </div>
                        <div class="accordion__title-caret">
                          <svg class="icon">
                            <use xlink:href="#chevron-down-smaller"></use>
                          </svg>
                        </div>
                      </a>
                      <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                        <div class="accordion__content">
                          <span class="tag tag--sm tag--free mb-10">Free Service</span>
                          <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that
                            to
                          build a new quote for you!</p>
                          <p>
                            <a href="mailto:help@everything.insure?subject=Quote%20request%20Everything.Insure&body=Hi%20there%0D%0A%0D%0APlease%20could%20you%20provide%20me%20with%20quotes%20for%20insurance%20to%20match%20my%20attached%20schedule.%0D%0A%0D%0ALook%20forward%20to%20hearing%20from%20you." class="button-control button-control--tight">
                              <svg class="icon icon--sm">
                                <use xlink:href="#upload"></use>
                                </svg><strong>Upload Schedule</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>Chat to a broker</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <p>Our licensed Everything.Insure brokers are ready to help you. Please get in
                            touch.</p>
                            <p class="chat-info__accordion-call">
                              <svg class="icon icon--sm">
                                <use xlink:href="#phone-filled"></use>
                              </svg>
                              <strong class="font-16">011 510 1300</strong>
                              <span>or</span>
                              <a href="#request-call-modal" data-toggle="modal"><strong>Request a
                              Call</strong></a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#" class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Let us help you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-info__emergency">
                  <a href="https://www.everything.insure/pages/everything.login.html" target="_blank">
                    <svg class="icon">
                      <use xlink:href="#navigation-sos"></use>
                    </svg>
                    Emergency services
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-sub__close d-none d-lg-block">
            <a href="javascript:;" (click)="closeDocument()" data-toggle="modal" class="icon-hover icon-hover--alt">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
}
@if (!pdfDoc && (user?.person_id || fromQuotePage)) {
  <div class="breadcrumbs">
    <ul class="breadcrumbs__list">
      @if (fromQuotePage) {
        @if (product_name) {
          <li>{{product_name}}</li>
        }
      } @else {
        <li><a href="javascript:;" [routerLink]="(user?.broker_id > 0 || user?.console_access) ? '/everything.policy-holders': '/everything.policies-landing'">Policies</a></li>
        @if (product_name) {
          <li><a href="javascript:;" routerLink="/everything.policy-overview">{{product_name}}</a></li>
        }
        <li><a href="javascript:;" routerLink="/everything.policy-resources">Documents</a></li>
      }
      <li>{{document?.document_name}}</li>
    </ul>
  </div>
}
<main class="page-main" id="main">
  <div [ngClass]="pdfDoc ? null:'layout layout--central'">
    <div [ngClass]="pdfDoc ? null:'layout__row'" id="main">

      @if (!pdfDoc) {
        <div class="layout__sidecol">
          <nav class="central-nav has-scrollto has-burger">
            <ul class="central-nav__list list-unstyled" id="docs-nav">
              @for (section of getSections(); track section; let i = $index) {
                <li [ngClass]=" i === 0 ? 'is-spied' : null">
                  @if (section?.section_name !== 'Header') {
                    <a [href]="'#anchor-' + section?.index"><span>{{section?.section_name}}</span></a>
                  }
                </li>
              }
            </ul>
            <div class="central-nav__burger">
              <svg class="icon">
                <use xlink:href="#menu"></use>
              </svg>
            </div>
          </nav>
        </div>
      }

      <div [ngClass]="pdfDoc ? null:'layout__bodycol'"  id="search-body">
        @if (pdfDoc) {
          <section  class="pdf-page pdf-page--cover">
            <div class="pdf-page__component">
              <header class="pdf__coverhead">
                <div class="pdf__coverhead-logo">
                  <span><img [src]="overview?.broker_logo_1" alt="Everything.Insure"></span>
                  <span class="pdf__coverhead-tagline"><img [src]="overview?.broker_logo_2" alt="Your only insurance platform"></span>
                </div>
                <div class="pdf__coverhead-company">
                  <img [src]="overview?.img_path" class="img-fluid">
                </div>
              </header>
              <div class="pdf__cover-details">
                <h1>{{overview?.header}}</h1>
                <ul class="list-unstyled">
                  <li>Last updated on <span class="font-semibold">{{overview?.doc_date}}</span></li>
                </ul>
              </div>
            </div>
          </section>
        }
        @if (pdfDoc) {
          <section class="pdf-page">
            <div class="pdf-page__component">
              <header class="pdf__coverhead">
                <div class="pdf__coverhead-logo">
                  <span><img [src]="overview?.broker_logo_1" alt="Everything.Insure"></span>
                </div>
                <div class="pdf__coverhead-title">
                  <h3>{{document?.document_name}}</h3>
                </div>
              </header>
              <div class="pdf__index">
                <!-- <h2 class="font-serif">Index</h2> -->
                <ul class="list-unstyled pdf-index">
                </ul>
              </div>
            </div>
            <footer class="pdf-page__footer">
              <div class="pdf-page__footer-inner">
                <img id="logo" [src]="footer?.img_path" alt="Everything.Insure">
                <p [innerHTML]="footer?.body"></p>
                <div>p. <span class="pdf-page-num"></span></div>
              </div>
            </footer>
          </section>
        }
        @for (section of getSections(); track section; let i = $index) {
          <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-{{section?.index}}" [attr.data-title]="section?.section_name">
            @if (section?.section_name !== 'Header') {
              <div  class="pdf-page__component">
                @if (i == 0 && !pdfDoc) {
                  <header  class="pdf__coverhead">
                    <div class="pdf__coverhead-logo">
                      <span><img [src]="overview?.broker_logo_1" alt="Everything.Insure"></span>
                      <span class="pdf__coverhead-tagline"><img [src]="overview?.broker_logo_2" alt="Your only insurance platform"></span>
                    </div>
                    <div class="pdf__coverhead-company">
                      <img [src]="overview?.img_path" class="img-fluid">
                    </div>
                  </header>
                }
                @if (i == 0 && !pdfDoc) {
                  <div class="pdf__cover-details">
                    <h1>{{overview?.header}}</h1>
                    <ul class="list-unstyled">
                      <li>Last updated on <span class="font-semibold">{{overview?.doc_date}}</span></li>
                    </ul>
                  </div>
                }
              </div>
            }
            @for (child of getSectionChildren(section?.section_name); track child; let i = $index) {
              <div class="pdf-page__component">
                @if (!child.html?.includes('pdf__data')) {
                  <div class="pdf__copy" [innerHtml]="child?.html"></div>
                }
                @if (child.html?.includes('pdf__data')) {
                  <div [innerHtml]="child?.html"></div>
                }
              </div>
            }
            @if (pdfDoc) {
              <footer class="pdf-page__footer">
                <div class="pdf-page__footer-inner">
                  <img id="logo" [src]="footer?.img_path" alt="Everything.Insure">
                  <p [innerHTML]="footer?.body"></p>
                  <div>p. <span class="pdf-page-num"></span></div>
                </div>
              </footer>
            }
          </section>
        }

      </div>
    </div>
  </div>
</main>
<div class="sidesheet sidesheet--menu" id="sidesheet">
  <div class="sidesheet__inner">

    <div class="sidesheet__body">

      <div class="has-scrollto">
        <ul class="central-nav__list list-unstyled" id="docs-nav-mobile">
          @for (section of getSections(); track section; let i = $index) {
            <li [ngClass]=" i === 0 ? 'is-spied' : null">
              @if (section?.section_name !== 'Header') {
                <a [href]="'#anchor-' + section?.index"><span>{{section?.section_name}}</span></a>
              }
            </li>
          }
        </ul>
      </div>

    </div>
  </div>
</div>
<div class="sidesheet__overlay"></div>
<div class="modal fade modal--alert" id="share-email-modal" tabindex="-1" role="dialog" aria-labelledby="share-email-modal" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Share via email</h3>
          </div>

          @for (email of emailControl; track email) {
            <div class="form-group has-action">
              <input type="email" value="" data-msg-error="Please enter a valid email address" placeholder="{{email?.placeholder}}" class="form-control emails">
              <a href="javascript:;" (click)="pop()" class="form-group__append action-clear">
                <svg class="icon"><use xlink:href="#trash"></use></svg>
              </a>
            </div>
          }
          <a href="javascript:;" (click)="push()" class="form-group__append action-clear">
            <svg class="icon"><use xlink:href="#plus"></use></svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
          <a href="javascript:;" (click)="emailDoc()" class="button button--lg button--primary" data-dismiss="modal" id="send-invites-btn">Share</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--tray" id="modal-share-menu" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-more" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">

          <a href="javascript:;" (click)="preparePDF()" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#download"></use>
            </svg>
            <div>Download</div>
          </a>
        </div>
        <a href="#" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
